import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import Container from '@mui/material/Container';
import { upperFirst } from 'lodash';
import styled from 'styled-components';

import { appRoutes } from '@/routes/constants';
import HeaderWithDivider from '@/operator/components/general/headers/HeaderWithDivider';
import { ConnectorForm } from '@/operator/components/general/multiStepForm/ConnectorForm';
import { connections } from '@/operator/components/modules/connections/utils';

export const HeadlineContainer = styled.div`
    justify-content: space-between;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    margin-bottom: 15px;
`;

export function AddNewConnections(): JSX.Element {
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const navigate = useOrgNavigate();
    const connectionName = searchParams.get('label');

    useEffect(() => {
        const connectionNameExists = connections.some(
            (connection) =>
                connection.toLowerCase() === connectionName?.toLowerCase(),
        );

        if (!connectionNameExists) {
            //Navigate to zendesk add as default
            navigate(
                `${appRoutes.OPERATOR_ADMIN_CONNECTIONS_ADD}}?label=${connections[0]}`,
            );
        }
    }, [connectionName]);

    return (
        <Container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 5,
                width: '100%',
            }}
        >
            <HeaderWithDivider
                header={
                    connectionName
                        ? `${upperFirst(connectionName)} ${t(
                            'Forms.Connections.Common.Connection',
                        )}`
                        : ''
                }
            />

            <ConnectorForm connectionName={connectionName || connections[0]} />
        </Container>
    );
}

export default AddNewConnections;
